import {
  GetBusinessListService,
  GetBusinessListByCategoryService,
  GetBusinessListByMultipleCategoriesService,
  GetBusinessListByNameService,
  GetListCategoriesService,
  GetListOfferProductsService
} from "../Infrastructure/Business.service";

export async function GetBusinessListLogic(zone) {
  return await GetBusinessListService(zone);
}

export async function GetBusinessListByCategoryLogic(zone, category) {
  return await GetBusinessListByCategoryService(zone, category);
}

export async function GetBusinessListByMultipleCategoriesLogic(zone, categories){
  return await GetBusinessListByMultipleCategoriesService(zone, categories);
}

export async function GetBusinessListByNameLogic(zone, name) {
  return await GetBusinessListByNameService(zone, name);
}

export async function GetListCategoriesLogic(){
  return await GetListCategoriesService();
}

export async function GetListOfferProductsLogic(id){
  return GetListOfferProductsService(id);
}